module.exports = __webpack_public_path__ + "static/img/332.c92f5115.jpg";